import React from "react";
import "./css/index.css";
import { makeComma, PeriodForm } from "../../../lib/lib";

type Props = {
  title: string;
  placeholder: string;
  max: number | undefined;
  type: string;
  reg: string;
  initial: string | number;
  __update: (type: string, payload: string | number) => void;
  error: string | undefined;
};

function WpInput({
  initial,
  title,
  placeholder,
  max,
  type,
  reg,
  __update,
  error,
}: Props) {
  return (
    <div className="wp-input">
      <div className="title">
        {title}
        <div className={`error-msg ${error ? "active-error" : ""}`}>
          {error}
        </div>
      </div>
      <div className={`input-wrapper ${error ? "error-wp" : ""}`}>
        <input
          type={type}
          placeholder={placeholder}
          maxLength={max}
          value={initial}
          onKeyDown={(e) => {
            if (e.keyCode === 38 || e.keyCode === 40) {
              e.preventDefault();
            }
          }}
          onChange={(e) => {
            const value = e.target.value;
            if (reg === "start" || reg === "finish" || reg === "finish_time") {
              if (value.length < 11) {
                __update(reg, PeriodForm(value));
              }
            } else if (reg === "price") {
              __update(reg, makeComma(value));
            } else if (reg === "percent") {
              __update(reg, Number(value) > 100 ? 100 : value);
            } else {
              __update(reg, value);
            }
          }}
        />
        {max ? (
          <div className="length">
            {String(initial).length}/{max}
          </div>
        ) : reg === "price" ? (
          <div className="length">원</div>
        ) : reg === "max" ? (
          <div className="length">명</div>
        ) : reg === "percent" ? (
          <div className="length">%</div>
        ) : undefined}
      </div>
    </div>
  );
}

export default WpInput;
